import React from 'react';
import PropTypes from 'prop-types';
import { fieldsType, condtionType } from 'types';
import FeatureField from '../FeatureField';

import './style.scss';

const FeaturesFieldArray = ({
  fields,
  condition,
  onDelete,
  onChangeFeatureValues,
}) => (
  <div styleName="features">
    {fields.map((field, index) => (
      <FeatureField
        item={fields.get(index)}
        key={field}
        index={index}
        feature={`${field}.feature`}
        equalsValues={`${field}.equals_values`}
        condition={condition}
        onDelete={onDelete}
        onChangeFeatureValues={onChangeFeatureValues}
      />
    ))}
  </div>
);

FeaturesFieldArray.propTypes = {
  condition: condtionType,
  fields: fieldsType,
  onDelete: PropTypes.func,
  onChangeFeatureValues: PropTypes.func,
};

export default FeaturesFieldArray;
